import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';
import { ConstantsUtil } from '@utils';
import { CLOSE_ALL_MODALS, CLOSE_MODAL, CLOSING_MODAL_WITH_ANSWER, INIT_CLOSE_ALL_MODALS, INIT_CLOSE_MODAL, INIT_MODAL_CLOSING_WITH_ANSWER, MODAL_INIT, SET_MODAL } from './modals.action-types';
export var actions = {
  /**
   * Init modal closing.
   *
   * @author Ihar Kazlouski
   * @function modalInitClosing
   * @category Actions
   * @subcategory Modals
   * @param {ModalClosePayload} payload payload.
   */
  modalInitClosing: function modalInitClosing(payload) {
    return {
      type: INIT_CLOSE_MODAL,
      payload: payload
    };
  },

  /**
   * Close modal.
   *
   * @author Ihar Kazlouski
   * @function modalClose
   * @category Actions
   * @subcategory Modals
   * @param {ModalClosePayload} payload payload.
   */
  modalClose: function modalClose(payload) {
    return {
      type: CLOSE_MODAL,
      payload: payload
    };
  },

  /**
   * Init closing all modals.
   *
   * @author Ihar Kazlouski
   * @function modalInitCloseAll
   * @category Actions
   * @subcategory Modals
   */
  modalInitCloseAll: function modalInitCloseAll() {
    return {
      type: INIT_CLOSE_ALL_MODALS
    };
  },

  /**
   * Close all modals.
   *
   * @author Ihar Kazlouski
   * @function modalCloseAll
   * @category Actions
   * @subcategory Modals
   */
  modalCloseAll: function modalCloseAll() {
    return {
      type: CLOSE_ALL_MODALS
    };
  },

  /**
   * Init modal opening.
   *
   * @author Ihar Kazlouski
   * @function modalInit
   * @category Actions
   * @subcategory Modals
   * @param {ModalPayload} payload payload.
   */
  modalInit: function modalInit(payload) {
    var _ref;

    return _ref = {
      type: MODAL_INIT,
      payload: payload
    }, _defineProperty(_ref, WAIT_FOR_ACTION, "".concat(MODAL_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)), _defineProperty(_ref, ERROR_ACTION, "".concat(MODAL_INIT, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)), _ref;
  },

  /**
   * Set necessary modal.
   *
   * @author Ihar Kazlouski
   * @function setModal
   * @category Actions
   * @subcategory Modals
   * @param {ModalPayload} payload payload.
   */
  setModal: function setModal(payload) {
    return {
      type: SET_MODAL,
      payload: payload
    };
  },

  /**
   * Init closing with answer.
   *
   * @author Ihar Kazlouski
   * @function modalInitClosingWithAnswer
   * @category Actions
   * @subcategory Modals
   * @param {ModalCloseWithAnswerPayload} payload payload.
   */
  modalInitClosingWithAnswer: function modalInitClosingWithAnswer(payload) {
    return {
      type: INIT_MODAL_CLOSING_WITH_ANSWER,
      payload: payload
    };
  },

  /**
   * Close modal with answer.
   *
   * @author Ihar Kazlouski
   * @function closeWithAnswer
   * @category Actions
   * @subcategory Modals
   * @param {ModalCloseWithAnswerPayload} payload payload.
   */
  closeWithAnswer: function closeWithAnswer(payload) {
    return {
      type: CLOSING_MODAL_WITH_ANSWER,
      payload: payload
    };
  }
};